let hideTimeout;

function slideDown(el) {
  el.style.display = 'block';
  const height = el.scrollHeight + 'px';
  el.style.height = '0';
  el.offsetHeight;
  el.style.height = height;
  el.style.opacity = '1';

  el.addEventListener('transitionend', function setAuto() {
    el.style.height = 'auto';
    el.removeEventListener('transitionend', setAuto);
  });
}

function slideUp(el) {
  el.style.height = el.scrollHeight + 'px';
  el.offsetHeight;
  el.style.height = '-16px';
  el.style.opacity = '0';

  el.addEventListener('transitionend', function hideEl() {
    el.style.display = 'none';
    el.removeEventListener('transitionend', hideEl);
  });
}

function clickHandler(event) {
  const content = document.querySelector('.tt_mdjhd');
  if (!content || event.target.closest('.tt_mdjhd')) return;

  const isVisible = content.classList.contains('show-note');

  if (isVisible) {
    clearTimeout(hideTimeout);
    content.classList.remove('show-note');
    slideUp(content);
  } else {
    content.classList.add('show-note');
    slideDown(content);
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      content.classList.remove('show-note');
      slideUp(content);
    }, 7000);
  }
}

function toggleContent() {
  const box = document.querySelector('.quote_desc_box_mdjhd');
  if (box) {
    box.removeEventListener('click', clickHandler);
    box.addEventListener('click', clickHandler);
  }
}

window.addEventListener('DOMContentLoaded', toggleContent);
